<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="text-primary">كشوفات أعمال المدرسة</h4>
          <p class="text-muted mb-0">
            نماذج ملف أعمال المدرسة بالاختبارات. اضغط أي نموذج لتحريره وتعبئته
            (مع اختيار المعلمين/الطلاب أو الإضافة يدوياً) ثم طباعته.
          </p>
        </div>
      </div>
    </div>

    <div
      class="col-12 col-md-6 col-lg-4"
      v-for="item in forms"
      :key="item.id"
      title="اضغط للتحرير والطباعة"
      @click="openMe(item.id)"
    >
      <div class="card kashf2">
        <div class="card-body d-flex align-items-center">
          <div class="num-badge">{{ item.num }}</div>
          <div class="flex-grow-1 px-1">
            <div class="font-weight-bold">{{ item.name }}</div>
            <small class="text-muted">{{ typeLabel(item.type) }}</small>
          </div>
          <img :src="require('@/assets/images/eye.png')" class="eye" />
        </div>
      </div>
    </div>
    <div class="col-12 text-center g">
      <a @click="$router.push('/_committees/kushof')" href="/_committees/kushof"><i class="fa fa-archive"></i> عرض الكشوف القديمة</a>
    </div>
  </div>
</template>

<script>
import { FORMS } from "./school-kushof-data";

export default {
  data() {
    return {
      forms: FORMS,
    };
  },
  methods: {
    typeLabel(t) {
      return (
        {
          committee: "قرار تشكيل لجنة",
          assignment: "قرار تكليف معلم",
          tracking: "جدول متابعة",
          envelope: "ظرف",
          minutes: "محضر",
          card: "بطاقة متابعة",
        }[t] || "نموذج"
      );
    },
    openMe(id) {
      window.open(`/_committees/school-kushof/${id}`);
    },
  },
};
</script>

<style scoped>
.kashf2 {
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
  border: 1px solid #ebe9f1;
}
.kashf2:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(34, 41, 47, 0.12);
}
.num-badge {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 10px;
  background: #7367f0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
}
.kashf2 .eye {
  width: 26px;
  opacity: 0.5;
}
</style>
